/** Set `window.enableOceanFriendsSync = true` in the browser console to show the push button. */
export const OCEAN_FRIENDS_SYNC_WINDOW_KEY = 'enableOceanFriendsSync';

type WindowWithOceanFriendsSync = Window & {
  [OCEAN_FRIENDS_SYNC_WINDOW_KEY]?: boolean;
};

export function isOceanFriendsSyncEnabled(): boolean {
  return localStorage.getItem(OCEAN_FRIENDS_SYNC_WINDOW_KEY) === 'true';
}

export function installOceanFriendsSyncToggle(): void {
  const w = window as WindowWithOceanFriendsSync;

  Object.defineProperty(w, OCEAN_FRIENDS_SYNC_WINDOW_KEY, {
    get: () => isOceanFriendsSyncEnabled(),
    set: (value: boolean) => {
      if (value) {
        localStorage.setItem(OCEAN_FRIENDS_SYNC_WINDOW_KEY, 'true');
      } else {
        localStorage.removeItem(OCEAN_FRIENDS_SYNC_WINDOW_KEY);
      }
    },
    configurable: true,
  });
}
